"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDL = void 0;
exports.IDL = {
    "version": "0.1.0",
    "name": "prediction_market",
    "instructions": [
        {
            "name": "initCategory",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "categoryAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "category",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "categoryId",
                    "type": {
                        "array": [
                            "u8",
                            20
                        ]
                    }
                },
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "addMarketListToCategory",
            "accounts": [
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "category",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketList",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "removeMarketListFromCategory",
            "accounts": [
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "category",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketList",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initMarketList",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "marketListAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "metadataAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "marketResolveAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "marketList",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "marketListId",
                    "type": {
                        "array": [
                            "u8",
                            20
                        ]
                    }
                },
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "initMarket",
            "accounts": [
                {
                    "name": "marketListAuthority",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "marketList",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketMetadata",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "marketId",
                    "type": {
                        "array": [
                            "u8",
                            1
                        ]
                    }
                },
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "writeToFieldMarketMetadata",
            "accounts": [
                {
                    "name": "marketMetadataAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "marketMetadata",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "string",
                    "type": "string"
                },
                {
                    "name": "field",
                    "type": {
                        "defined": "MarketMetadataFields"
                    }
                }
            ]
        },
        {
            "name": "appendToFieldMarketMetadata",
            "accounts": [
                {
                    "name": "marketMetadataAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "marketMetadata",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "string",
                    "type": "string"
                },
                {
                    "name": "field",
                    "type": {
                        "defined": "MarketMetadataFields"
                    }
                }
            ]
        },
        {
            "name": "writeMarketEndToMetadata",
            "accounts": [
                {
                    "name": "marketMetadataAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "marketMetadata",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "marketEnd",
                    "type": "i64"
                }
            ]
        },
        {
            "name": "initBracketStepOne",
            "accounts": [
                {
                    "name": "marketListAuthority",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "marketList",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bumps",
                    "type": {
                        "defined": "BracketBumps"
                    }
                },
                {
                    "name": "bracketId",
                    "type": {
                        "array": [
                            "u8",
                            1
                        ]
                    }
                }
            ]
        },
        {
            "name": "initBracketStepTwo",
            "accounts": [
                {
                    "name": "marketListAuthority",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "marketList",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "requestQueue",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "coinVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultSigner",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "eventQueue",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bids",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "asks",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "serumBumps",
                    "type": {
                        "defined": "SerumBumps"
                    }
                }
            ]
        },
        {
            "name": "initInternalUsdc",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "internalTokenAuth",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "internalTokenAuthBump",
                    "type": "u8"
                },
                {
                    "name": "internalUsdcBump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "initMarketPnl",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "transferInternalUsdcToUser",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalTokenAuth",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initTradesYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bumps",
                    "type": {
                        "defined": "TradeYesBumps"
                    }
                }
            ]
        },
        {
            "name": "buyYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "limitPrice",
                    "type": "u64"
                },
                {
                    "name": "coinAmount",
                    "type": "u64"
                },
                {
                    "name": "orderType",
                    "type": {
                        "defined": "OrderType"
                    }
                },
                {
                    "name": "clientOrderId",
                    "type": {
                        "option": "u64"
                    }
                }
            ]
        },
        {
            "name": "sellYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "limitPrice",
                    "type": "u64"
                },
                {
                    "name": "coinAmount",
                    "type": "u64"
                },
                {
                    "name": "orderType",
                    "type": {
                        "defined": "OrderType"
                    }
                },
                {
                    "name": "clientOrderId",
                    "type": {
                        "option": "u64"
                    }
                }
            ]
        },
        {
            "name": "cancelTradeYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "side",
                    "type": {
                        "defined": "Side"
                    }
                },
                {
                    "name": "orderId",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "consumeAndSettleTradeYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initBuyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bumps",
                    "type": {
                        "defined": "BuyNoBumps"
                    }
                }
            ]
        },
        {
            "name": "buyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "limitPrice",
                    "type": "u64"
                },
                {
                    "name": "coinAmount",
                    "type": "u64"
                },
                {
                    "name": "orderType",
                    "type": {
                        "defined": "OrderType"
                    }
                },
                {
                    "name": "clientOrderId",
                    "type": {
                        "option": "u64"
                    }
                }
            ]
        },
        {
            "name": "cancelBuyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "orderId",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "consumeAndSettleBuyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initSellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bumps",
                    "type": {
                        "defined": "SellNoBumps"
                    }
                }
            ]
        },
        {
            "name": "sellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "limitPrice",
                    "type": "u64"
                },
                {
                    "name": "coinAmount",
                    "type": "u64"
                },
                {
                    "name": "orderType",
                    "type": {
                        "defined": "OrderType"
                    }
                },
                {
                    "name": "clientOrderId",
                    "type": {
                        "option": "u64"
                    }
                }
            ]
        },
        {
            "name": "cancelSellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "userUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "orderId",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "consumeAndSettleSellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "resolveMarket",
            "accounts": [
                {
                    "name": "marketResolveAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "marketList",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "winningBracket",
                    "type": "i8"
                }
            ]
        },
        {
            "name": "pruneOrdersTradeYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "pruneOrdersBuyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "pruneOrdersSellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "fUsdcMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "closeSerumMarket",
            "accounts": [
                {
                    "name": "destination",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketList",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "serumAccounts",
                    "accounts": [
                        {
                            "name": "requestQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "eventQueue",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "bids",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "asks",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "coinVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "pcVault",
                            "isMut": true,
                            "isSigner": false
                        },
                        {
                            "name": "vaultSigner",
                            "isMut": false,
                            "isSigner": false
                        }
                    ]
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "redeemWinningYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "yesMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "redeemWinningNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "usdcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "noMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "marketPnl",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "closeAccountsTradeYes",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalTokenAuth",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "closeAccountsBuyNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "unlockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalTokenAuth",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "closeAccountsSellNo",
            "accounts": [
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tradeNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bracket",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "serumMarket",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedYes",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedNo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "lockedFUsdc",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "internalTokenAuth",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        }
    ],
    "accounts": [
        {
            "name": "category",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "authority",
                        "type": "publicKey"
                    },
                    {
                        "name": "id",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "marketListIds",
                        "type": {
                            "vec": {
                                "array": [
                                    "u8",
                                    20
                                ]
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "marketList",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "authority",
                        "type": "publicKey"
                    },
                    {
                        "name": "metadataAuthority",
                        "type": "publicKey"
                    },
                    {
                        "name": "marketResolveAuthority",
                        "type": "publicKey"
                    },
                    {
                        "name": "id",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "numMarkets",
                        "type": "u8"
                    },
                    {
                        "name": "markets",
                        "type": {
                            "vec": {
                                "defined": "MarketInfo"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "market",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "id",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "marketListId",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "marketListIndex",
                        "type": "u8"
                    },
                    {
                        "name": "isResolved",
                        "type": "bool"
                    },
                    {
                        "name": "winningBracket",
                        "type": "i8"
                    }
                ]
            }
        },
        {
            "name": "marketMetadata",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "authority",
                        "type": "publicKey"
                    },
                    {
                        "name": "title",
                        "type": "bytes"
                    },
                    {
                        "name": "description",
                        "type": "bytes"
                    },
                    {
                        "name": "image",
                        "type": "bytes"
                    },
                    {
                        "name": "marketStart",
                        "type": "i64"
                    },
                    {
                        "name": "marketEnd",
                        "type": "i64"
                    },
                    {
                        "name": "marketName",
                        "type": "bytes"
                    },
                    {
                        "name": "rules",
                        "type": "bytes"
                    }
                ]
            }
        },
        {
            "name": "bracket",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "id",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketListId",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "signerBump",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "bumps",
                        "type": {
                            "defined": "BracketBumps"
                        }
                    },
                    {
                        "name": "serumBumps",
                        "type": {
                            "defined": "SerumBumps"
                        }
                    },
                    {
                        "name": "bidQueue",
                        "type": "publicKey"
                    },
                    {
                        "name": "askQueue",
                        "type": "publicKey"
                    },
                    {
                        "name": "eventQueue",
                        "type": "publicKey"
                    },
                    {
                        "name": "isSerumMarketInit",
                        "type": "bool"
                    },
                    {
                        "name": "isSerumMarketClosed",
                        "type": "bool"
                    },
                    {
                        "name": "maxBids",
                        "type": "u16"
                    },
                    {
                        "name": "maxAsks",
                        "type": "u16"
                    }
                ]
            }
        },
        {
            "name": "tradeYes",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user",
                        "type": "publicKey"
                    },
                    {
                        "name": "signerBump",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "bracketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketListId",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "bumps",
                        "type": {
                            "defined": "TradeYesBumps"
                        }
                    }
                ]
            }
        },
        {
            "name": "tradeNo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user",
                        "type": "publicKey"
                    },
                    {
                        "name": "signerBump",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "bracketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketListId",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "buyNoBumps",
                        "type": {
                            "defined": "BuyNoBumps"
                        }
                    },
                    {
                        "name": "sellNoBumps",
                        "type": {
                            "defined": "SellNoBumps"
                        }
                    },
                    {
                        "name": "buyNoBorrowedTotal",
                        "type": "u64"
                    },
                    {
                        "name": "sellNoBorrowedTotal",
                        "type": "u64"
                    },
                    {
                        "name": "buyNoOpenOrders",
                        "type": "publicKey"
                    },
                    {
                        "name": "sellNoOpenOrders",
                        "type": "publicKey"
                    },
                    {
                        "name": "buyNoLockedNoTotal",
                        "type": "u64"
                    },
                    {
                        "name": "noForSale",
                        "type": "u64"
                    },
                    {
                        "name": "hasSellNoBeenInit",
                        "type": "bool"
                    },
                    {
                        "name": "hasBuyNoBeenClosed",
                        "type": "bool"
                    },
                    {
                        "name": "hasSellNoBeenClosed",
                        "type": "bool"
                    }
                ]
            }
        },
        {
            "name": "internalTokenAuth",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user",
                        "type": "publicKey"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "signerBump",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "internalUsdcBump",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "marketPnl",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user",
                        "type": "publicKey"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "marketId",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "marketListId",
                        "type": {
                            "array": [
                                "u8",
                                20
                            ]
                        }
                    },
                    {
                        "name": "pnl",
                        "type": "i64"
                    }
                ]
            }
        }
    ],
    "types": [
        {
            "name": "MarketInfo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "id",
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "numBrackets",
                        "type": "u8"
                    },
                    {
                        "name": "isResolved",
                        "type": "bool"
                    },
                    {
                        "name": "winningBracket",
                        "type": "i8"
                    }
                ]
            }
        },
        {
            "name": "BracketBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market",
                        "type": "u8"
                    },
                    {
                        "name": "bracket",
                        "type": "u8"
                    },
                    {
                        "name": "usdcVault",
                        "type": "u8"
                    },
                    {
                        "name": "yesMint",
                        "type": "u8"
                    },
                    {
                        "name": "noMint",
                        "type": "u8"
                    },
                    {
                        "name": "fUsdcMint",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "SerumBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "serumMarket",
                        "type": "u8"
                    },
                    {
                        "name": "requestQueue",
                        "type": "u8"
                    },
                    {
                        "name": "coinVault",
                        "type": "u8"
                    },
                    {
                        "name": "pcVault",
                        "type": "u8"
                    },
                    {
                        "name": "vaultSigner",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "TradeYesBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "tradeYes",
                        "type": "u8"
                    },
                    {
                        "name": "openOrders",
                        "type": "u8"
                    },
                    {
                        "name": "unlockedYes",
                        "type": "u8"
                    },
                    {
                        "name": "lockedFUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "internalUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "marketPnl",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "BuyNoBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "tradeNo",
                        "type": "u8"
                    },
                    {
                        "name": "openOrders",
                        "type": "u8"
                    },
                    {
                        "name": "lockedYes",
                        "type": "u8"
                    },
                    {
                        "name": "lockedNo",
                        "type": "u8"
                    },
                    {
                        "name": "unlockedNo",
                        "type": "u8"
                    },
                    {
                        "name": "lockedFUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "internalUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "marketPnl",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "SellNoBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "tradeNo",
                        "type": "u8"
                    },
                    {
                        "name": "openOrders",
                        "type": "u8"
                    },
                    {
                        "name": "lockedYes",
                        "type": "u8"
                    },
                    {
                        "name": "lockedNo",
                        "type": "u8"
                    },
                    {
                        "name": "unlockedNo",
                        "type": "u8"
                    },
                    {
                        "name": "lockedFUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "internalUsdc",
                        "type": "u8"
                    },
                    {
                        "name": "marketPnl",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "MarketMetadataFields",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Description"
                    },
                    {
                        "name": "Title"
                    },
                    {
                        "name": "Image"
                    },
                    {
                        "name": "MarketEnd"
                    },
                    {
                        "name": "MarketName"
                    },
                    {
                        "name": "Rules"
                    }
                ]
            }
        },
        {
            "name": "OrderType",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Limit"
                    },
                    {
                        "name": "ImmediateOrCancel"
                    }
                ]
            }
        },
        {
            "name": "Side",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Bid"
                    },
                    {
                        "name": "Ask"
                    }
                ]
            }
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "NotImplemented",
            "msg": "Function not yet implemented"
        },
        {
            "code": 6001,
            "name": "InvalidPrice",
            "msg": "Price must be between $0.001 and $0.999 per token"
        },
        {
            "code": 6002,
            "name": "InvalidQuantityLots",
            "msg": "Orders must be a multiple of $0.01"
        },
        {
            "code": 6003,
            "name": "InsufficientUsdc",
            "msg": "Insufficient USDC"
        },
        {
            "code": 6004,
            "name": "InsufficientTokens",
            "msg": "Insufficient tokens"
        },
        {
            "code": 6005,
            "name": "NonzeroLockedYes",
            "msg": "Locked Yes should have 0 tokens, if this happens your account is bricked somehow"
        },
        {
            "code": 6006,
            "name": "NonzeroLockedFUsdc",
            "msg": "Locked fUsdc should have 0 tokens, if this happens your account is bricked somehow"
        },
        {
            "code": 6007,
            "name": "NonzeroTempAccount",
            "msg": "Temporary account should have 0 tokens"
        },
        {
            "code": 6008,
            "name": "MarketHasResolved",
            "msg": "Cannot place an order, market has resolved"
        },
        {
            "code": 6009,
            "name": "MarketHasNotResolved",
            "msg": "Market has not yet resolved"
        },
        {
            "code": 6010,
            "name": "WinningBracketIdInvalid",
            "msg": "Winning bracket id is invalid"
        },
        {
            "code": 6011,
            "name": "BracketHasNotResolvedToYes",
            "msg": "This Bracket has not resolved to Yes"
        },
        {
            "code": 6012,
            "name": "BracketHasNotResolvedToNo",
            "msg": "This Bracket has not resolved to No"
        },
        {
            "code": 6013,
            "name": "SerumMarketNotClosed",
            "msg": "Serum market hasn't been closed yet"
        },
        {
            "code": 6014,
            "name": "SerumMarketHasBeenClosed",
            "msg": "Serum market has been closed already"
        },
        {
            "code": 6015,
            "name": "InvalidLotSizes",
            "msg": "Serum market lot sizes don't match expected values"
        },
        {
            "code": 6016,
            "name": "MarketListHasNoBrackets",
            "msg": "A MarketList without brackets cannot be added to a category"
        },
        {
            "code": 6017,
            "name": "OneMarketPerMarketList",
            "msg": "Deprecating market list; only one market allowed per market list"
        },
        {
            "code": 6018,
            "name": "TooManyBids",
            "msg": "Too many orders on the bid queue, please prune orders"
        },
        {
            "code": 6019,
            "name": "TooManyAsks",
            "msg": "Too many orders on the ask queue, please prune orders"
        },
        {
            "code": 6020,
            "name": "NoOrdersInOpenOrders",
            "msg": "No orders in this open orders account"
        },
        {
            "code": 6021,
            "name": "MarketListIdIsAlreadyInCategory",
            "msg": "The market list id to be added is already in the category"
        },
        {
            "code": 6022,
            "name": "MarketListIdNotInCategory",
            "msg": "The market list id to be removed is not in the category"
        },
        {
            "code": 6023,
            "name": "InvalidFieldEnum",
            "msg": "The field enum passed in doesn't match any in the match statement"
        }
    ]
};
//# sourceMappingURL=prediction_market.js.map